<template>
  <div>
    <div
      class="botones-container"
      v-if="globalConfig.showFastFilter && permiteFastFilter"
    >
      <v-btn class="stats-button" dark @click="verAsignadas">
        Asignadas ({{ counts.asignadas }})
      </v-btn>

      <v-btn class="stats-button" dark @click="verTramite">
        En trámite ({{ counts.enTramite }})
      </v-btn>

      <v-btn class="stats-button" dark @click="verPendientes">
        Pendientes ({{ counts.pendientes }})
      </v-btn>
    </div>
    <CommonExpansionPanel :currentPanel="0">
      <template v-slot:title-panel>
        Buscar
      </template>

      <v-expansion-panel-content>
        <div v-if="area_negocio == 6 || area_negocio == 3">
          <FiltersAreaEmailsSolicitudes
            @getAreaNegocioFilters="actualizarFiltros"
            :loading="loading"
          />
        </div>
        <div v-else>
          <filters-solicitudes
            @searchUpdated="getSolicitudes"
            :currentFilters="filtros"
            :loading="loading"
          ></filters-solicitudes>
        </div>

        <hr />
        <div v-if="area_negocio == 6 || area_negocio == 3">
          <TableAreaNegocioSolicitudes
            :total="total"
            :loading="loading"
            :solicitudes="solicitudes"
            :restartPaginacion="restartPaginacion"
            @restartFlag="restartPaginacion = false"
            @seleccionSolicitud="seleccionSolicitud"
            @paginacionModificada="paginacionModificada"
          />
        </div>
        <div v-else>
          <table-solicitudes
            :loading="loading"
            :solicitudes="solicitudes"
            @seleccionSolicitud="seleccionSolicitud"
          ></table-solicitudes>
        </div>
      </v-expansion-panel-content>
    </CommonExpansionPanel>
  </div>
</template>

<script>
import CommonExpansionPanel from "@/components/commonComponents/CommonExpansionPanel.vue";
import FiltersSolicitudes from "./FiltersSolicitudes.vue";
import TableSolicitudes from "./TableSolicitudes.vue";
import { mainAxios } from "@/mainAxios.js";
import FiltersAreaEmailsSolicitudes from "./FiltrosAreaNegocio/FiltersAreaEmailsSolicitudes.vue";
import {
  getCountStatusSolicitudes,
  getSolicitudesFiltrosAreaNegocio,
} from "@/services/solicitudes/Solicitudes.js";
import TableAreaNegocioSolicitudes from "./FiltrosAreaNegocio/TableAreaNegocioSolicitudes.vue";

export default {
  components: {
    CommonExpansionPanel,
    FiltersSolicitudes,
    TableSolicitudes,
    FiltersAreaEmailsSolicitudes,
    TableAreaNegocioSolicitudes,
  },

  data() {
    return {
      switch_data: 1,
      solicitudes: [],
      filtros: {},
      loading: false,
      area_negocio: localStorage.getItem("area_negocio_id"),
      areas_negocio: localStorage.getItem("areasNegocio").split(",").map((v) => Number(v.trim())),
      rol: JSON.parse(localStorage.getItem("roles"))[0]?.rol || "",
      total: 0,
      elementosPagina: 10,
      pagina: 1,
      restartPaginacion: false,
      areaNegocioId: null,
      order: "asc`",
      counts: {
        asignadas: 0,
        enTramite: 0,
        pendientes: 0,
      },
      globalConfig: JSON.parse(localStorage.getItem("globalConfig")) ?? {},
    };
  },
  props: {
    contactData: Object,
    correosDataFormat: Object,
    routesContactData: Object,
    isModal: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    permiteFastFilter() {
      return ["BACKOFFICEEMAILS", "BACKOFFICEINBOUND"].includes(this.rol);
    },
  },
  methods: {
    getSolicitudes(body) {
      const alianzaIdFromUrl = this.$route.params.alianza_id;
      const alianzaIdFromStorage =
        localStorage.alianzaId !== "null" ? localStorage.alianzaId : null;
      const alianzaId = alianzaIdFromUrl || alianzaIdFromStorage || null;

      if (alianzaId) {
        body.alianza_id = alianzaId;
      } else {
        delete body.alianza_id;
      }
      body.status = 8; // Selecciona solicitudes en cualquier estado
      const requestConfig = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      //add to the body the id if is Agent
      if (localStorage.getItem("rolNotAdmin") === "AGENT")
      {  body.agente_id = Number(localStorage.getItem("id")); }
      this.loading = true;
      mainAxios
        .post(
          `/v1/solicitud/list/${localStorage.agenteUuid}`,
          body,
          requestConfig
        )
        .then(({ data }) => {
          this.loading = false;
          if (data.length) this.solicitudes = data;
          else this.solicitudes = [];
          this.filtros = body;
        });
    },
    getTodasLasSolicitudes() {
      const requestConfig = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      mainAxios
        .get(`/v1/solicitud/info/status/1`, requestConfig)
        .then(({ data }) => {
          this.todasLasSolicitudes = data;
        });
    },
    seleccionSolicitud(val) {
      this.$emit("seleccionSolicitud", val);
    },
    actualizarFiltros(filters, areaNegocioId) {
      this.filtros = filters;
      this.elementosPagina = 10;
      this.pagina = 1;
      this.restartPaginacion = true;
      this.areaNegocioId = areaNegocioId;
      this.order = "asc";
      this.getSolicitudesAreaNegocio();
    },
    async getSolicitudesAreaNegocio() {
      this.loading = true;
      let response = await getSolicitudesFiltrosAreaNegocio(
        this.filtros,
        this.elementosPagina,
        Number(this.pagina) - 1,
        this.areaNegocioId,
        this.order
      );
      this.loading = false;
      if (response.data.length) {
        this.total = response.total;
        this.solicitudes = response.data;
      } else {
        this.solicitudes = [];
        this.total = 0;
      }
    },
    paginacionModificada(paginacion) {
      console.log({ paginacion });
      this.elementosPagina = paginacion.elementosPagina;
      this.pagina = paginacion.pagina;
      this.order = paginacion.order;
      console.log(this.order);
      console.log(this.filtros);
      if (!this.isEmptyObject(this.filtros)) this.getSolicitudesAreaNegocio();
    },
    isEmptyObject(obj) {
      return (
        obj !== null &&
        typeof obj === "object" &&
        !Array.isArray(obj) &&
        Object.keys(obj).length === 0
      );
    },
    async getCountSolicitudes() {
      let res;
      if (this.areas_negocio) {
        res = await getCountStatusSolicitudes(this.areas_negocio);
      } else {
        res = await getCountStatusSolicitudes();
      }

      const data = res.data;
      const asignadas = data.find((item) => item.status === 1)?.total || 0;
      const enTramite = data.find((item) => item.status === 2)?.total || 0;
      const pendientes =
        data.find((item) => [3, 4, 15].includes(item.status))?.total || 0;

      this.counts = {
        asignadas,
        enTramite,
        pendientes,
      };
    },
    aplicarFiltroPorEstado(status) {
      const agentId = Number(localStorage.getItem("id"));
      if (this.area_negocio == 6 || this.area_negocio == 3) {
        const filter = { status, operador_id: agentId };
        this.actualizarFiltros(filter, this.area_negocio);
      } else {
        const filter = { status, ejecutivo_operaciones_id: agentId };
        this.getSolicitudes(filter);
      }
    },
    verAsignadas() {
      this.aplicarFiltroPorEstado(1);
    },
    verTramite() {
      this.aplicarFiltroPorEstado(2);
    },
    verPendientes() {
      this.aplicarFiltroPorEstado([3, 4, 15]);
    },
  },
  mounted() {
    if (
      String(window.location.pathname).includes("/alianza/perfil/") ||
      String(window.location.pathname).includes("/perfil/alianza")
    ) {
      this.getSolicitudes({});
    }
    this.getCountSolicitudes();
  },
};
</script>

<style scoped>
.botones-container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-around;
  margin-bottom: 20px;
}

.stats-button {
  background-color: #00a7e4 !important;
  border-radius: 15px;
  width: 300px;
  height: 65px !important;
  font-size: large;
  font-weight: bold;
}
</style>
